import { studentRequests } from "api/studentApi";
import React from "react";
import {
  BooleanField,
  Datagrid,
  DateField,
  FunctionField,
  List,
  ReferenceArrayField,
  ReferenceField,
  ReferenceInput,
  SelectInput,
  SimpleList,
  SingleFieldList,
  TextField,
} from "react-admin";
import RoomField from "server/components/Fields/RoomField";
import GradesModal from "./GradesModal";
import { getProfessorRecordText } from "server/components/Fields/_fieldsHelper";
import { Chip, useMediaQuery } from "@mui/material";
import ProfessorInput from "server/components/Fields/ProfessorInput";
import { employeeRequests } from "api/employeeApi";
import { administrationRequests } from "api/administrationApi";
import { MOBILE_BREAKPOINT } from "utils/constants";
import { settings } from "app";
import { MobileListRow } from "features/MobileListRow";
import { formatDateOnlyBg } from "server/formatting/formatDateBg";

const ListGrades = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  const gradesFilters = [
    <ReferenceInput
      source="structuralUnitId"
      reference={administrationRequests.getStructuralUnitsSelect()}
      label="Структурна единица"
      alwaysOn
    >
      <SelectInput
        label="Структурна единица"
        emptyText="Всички"
        style={{ width: 300 }}
      />
    </ReferenceInput>,
    <ProfessorInput
      source="professorEmployeeId"
      alwaysOn
      style={{ width: 300 }}
    />,
    <ReferenceInput
      source="sessionType"
      reference={studentRequests.getAcademicSessionTypesSelect()}
      fullWidth
      alwaysOn
    >
      <SelectInput
        label="Тип сесия"
        optionText="name"
        emptyText={false}
      />
    </ReferenceInput>,
  ];
  return (
    <List
      exporter={false}
      title="Оценки"
      filters={gradesFilters}
    >
      {isMobile ? (
        <SimpleList
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => (
            <div>
              <MobileListRow
                fields={[
                  {
                    label: "Дисциплина",
                    value: (
                      <ReferenceField
                        source="disciplineId"
                        reference={administrationRequests.getDisciplinesSelect()}
                      >
                        <TextField source="name" />
                      </ReferenceField>
                    ),
                  },
                ]}
              />
              <MobileListRow fields={[{ label: "Дата", value: formatDateOnlyBg(record?.date) }]} />
            </div>
          )}
          secondaryText={record => (
            <div>
              <MobileListRow fields={[{ label: "Бележка", value: record?.note ?? "-" }]} />
              <MobileListRow
                fields={[
                  { label: "От", value: record?.startTime },
                  { label: "До", value: record?.endTime },
                ]}
              />
              <MobileListRow fields={[{ label: "Зала", value: <RoomField label="Зала" /> }]} />
              <MobileListRow
                fields={[
                  {
                    label: "Преподаватели",
                    value: (
                      <ReferenceArrayField
                        source="professorIds"
                        reference={employeeRequests.getProfessorsSelect()}
                      >
                        <SingleFieldList linkType={false}>
                          <FunctionField
                            render={rec => (
                              <Chip
                                label={getProfessorRecordText(rec)}
                                size="small"
                              />
                            )}
                          />
                        </SingleFieldList>
                      </ReferenceArrayField>
                    ),
                  },
                ]}
              />
              <MobileListRow
                fields={[
                  {
                    label: "Учебни групи",
                    value: record?.studyGroups?.length > 0 ? record?.studyGroups.join(", ") : "-",
                  },
                ]}
              />
              <MobileListRow
                fields={[{ label: "Положен изпит?", value: record?.examPassed ? "Да" : "Не" }]}
              />
              <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
                {record?.examPassed ? <GradesModal item={record} /> : null}
              </div>
            </div>
          )}
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
        >
          <ReferenceField
            source="disciplineId"
            reference={administrationRequests.getDisciplinesSelect()}
            label="Дисциплина"
          >
            <TextField source="name" />
          </ReferenceField>
          <TextField
            source="note"
            label="Бележка"
            sortable={false}
            emptyText="-"
          />
          <DateField
            label="Дата"
            source="date"
            sortable={false}
            locales="bg-BG"
          />
          <TextField
            label="От"
            source="startTime"
            sortable={false}
          />
          <TextField
            label="До"
            source="endTime"
            sortable={false}
          />
          <RoomField label="Зала" />

          <ReferenceArrayField
            label="Преподаватели"
            source="professorIds"
            reference={employeeRequests.getProfessorsSelect()}
          >
            <SingleFieldList linkType={false}>
              <FunctionField
                render={record => (
                  <Chip
                    label={getProfessorRecordText(record)}
                    size="small"
                  />
                )}
              />
            </SingleFieldList>
          </ReferenceArrayField>
          <FunctionField
            label="Учебни групи"
            render={record => (record?.studyGroups?.length > 0 ? record?.studyGroups.join(", ") : "-")}
          />
          <BooleanField
            source="examPassed"
            label="Положен изпит?"
          />
          <FunctionField render={rec => (rec.examPassed ? <GradesModal item={rec} /> : null)} />
        </Datagrid>
      )}
    </List>
  );
};

export default ListGrades;
